var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "blockchain_data_table"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.blockchains,
      "headers": _vm.headers,
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "chain_logo_name"
        }, [_c('div', {
          staticClass: "chain_avatar",
          style: {
            backgroundColor: _vm.chainDarkColor(item.id)
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.chainCode(item.id)) + " ")])]), _vm.links ? _c('router-link', {
          staticClass: "chain_name",
          attrs: {
            "to": "/blockchain/".concat(item.id)
          }
        }, [_vm._v(_vm._s(item.name))]) : _c('span', {
          staticClass: "chain_name"
        }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1)];
      }
    }, {
      key: "item.indexed",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('Indexed', {
          attrs: {
            "indexed": item.indexed,
            "not-indexed-label": false
          }
        })];
      }
    }, {
      key: "item.vmID",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('div', [_c('a', {
          attrs: {
            "href": _vm.vmDocumentation(item.vmID)
          }
        }, [_c('p', [_vm._v(_vm._s(_vm.vmFullName(item.vmID)))]), _c('p', {
          staticClass: "vm_abbrev"
        }, [_vm._v(_vm._s(_vm.vm(item.vmID)))])])])];
      }
    }, {
      key: "item.subnetID",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('div', [_c('router-link', {
          attrs: {
            "to": "/subnet/".concat(item.subnetID)
          }
        }, [_vm._v(_vm._s(_vm._f("subnet")(item.subnetID)))])], 1)];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }